import * as tslib_1 from "tslib";
import api from 'src/api';
import { observable } from 'mobx';
var FeaturesStore = /** @class */ (function () {
    function FeaturesStore() {
        var _this = this;
        this.features = {
            version: null,
            gitlabIntegration: false,
            developerDocumentation: false
        };
        api.get('api/features').then(function (_a) {
            var data = _a.data;
            _this.features = data;
            _this.setVersionTitle();
        });
    }
    FeaturesStore.prototype.setVersionTitle = function () {
        if (this.features.version) {
            document.title = document.title + (" v" + this.features.version);
        }
    };
    tslib_1.__decorate([
        observable
    ], FeaturesStore.prototype, "features", void 0);
    return FeaturesStore;
}());
export default FeaturesStore;



//////////////////
// WEBPACK FOOTER
// ./src/store/FeaturesStore.ts
// module id = 374
// module chunks = 0